module.exports = new __parcel__URL__("dribbble.d2d23e80.png").toString();